import { Component, OnInit } from '@angular/core';
import { RootMixin, UserAwareMixin } from '@asp/mixins';
import { AuthService } from '@asp/authentication';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent
  extends UserAwareMixin(RootMixin)
  implements OnInit
{
  luser: Observable<any>;
  constructor(private auth: AuthService) {
    super();
  }

  ngOnInit(): void {
    this.luser = this.currentUser.valueChanges.pipe(
      map((res: any) => res.data.currentUser),
    );
  }

  logout() {
    this.auth.logout();
  }
}
